/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSupplierWithOrganizationDto
 */
export interface CreateSupplierWithOrganizationDto {
    /**
     * Supplier first name
     * @type {string}
     * @memberof CreateSupplierWithOrganizationDto
     */
    firstName: string;
    /**
     * Supplier last name
     * @type {string}
     * @memberof CreateSupplierWithOrganizationDto
     */
    lastName: string;
    /**
     * Supplier email address
     * @type {string}
     * @memberof CreateSupplierWithOrganizationDto
     */
    email: string;
    /**
     * Supplier phone number in international format
     * @type {string}
     * @memberof CreateSupplierWithOrganizationDto
     */
    phoneNumber: string;
    /**
     * Supplier password (will be hashed)
     * @type {string}
     * @memberof CreateSupplierWithOrganizationDto
     */
    password: string;
    /**
     * Supplier roles array
     * @type {Array<string>}
     * @memberof CreateSupplierWithOrganizationDto
     */
    roles: Array<CreateSupplierWithOrganizationDtoRolesEnum>;
    /**
     * Is supplier confirmed by admin
     * @type {boolean}
     * @memberof CreateSupplierWithOrganizationDto
     */
    isConfirmed: boolean;
}


/**
 * @export
 */
export const CreateSupplierWithOrganizationDtoRolesEnum = {
    GlobalSupplierAdmin: 'GLOBAL_SUPPLIER_ADMIN',
    PromotionSupplierAdmin: 'PROMOTION_SUPPLIER_ADMIN',
    CatalogSupplierAdmin: 'CATALOG_SUPPLIER_ADMIN',
    OrderSupplierAdmin: 'ORDER_SUPPLIER_ADMIN',
    AddProductSupplierAdmin: 'ADD_PRODUCT_SUPPLIER_ADMIN',
    ReadOnlySupplierAdmin: 'READ_ONLY_SUPPLIER_ADMIN'
} as const;
export type CreateSupplierWithOrganizationDtoRolesEnum = typeof CreateSupplierWithOrganizationDtoRolesEnum[keyof typeof CreateSupplierWithOrganizationDtoRolesEnum];


/**
 * Check if a given object implements the CreateSupplierWithOrganizationDto interface.
 */
export function instanceOfCreateSupplierWithOrganizationDto(value: object): value is CreateSupplierWithOrganizationDto {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('isConfirmed' in value) || value['isConfirmed'] === undefined) return false;
    return true;
}

export function CreateSupplierWithOrganizationDtoFromJSON(json: any): CreateSupplierWithOrganizationDto {
    return CreateSupplierWithOrganizationDtoFromJSONTyped(json, false);
}

export function CreateSupplierWithOrganizationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSupplierWithOrganizationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'phoneNumber': json['phoneNumber'],
        'password': json['password'],
        'roles': json['roles'],
        'isConfirmed': json['isConfirmed'],
    };
}

export function CreateSupplierWithOrganizationDtoToJSON(value?: CreateSupplierWithOrganizationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'password': value['password'],
        'roles': value['roles'],
        'isConfirmed': value['isConfirmed'],
    };
}

